import { deleteData, getData, postData, putData } from "./apiMethod";
import { useContext } from "react";
import { AppContext } from "../contexts/AppContext";
import { useNavigate } from "react-router-dom";

export const useCrudForm = () => {
    const { setUser } = useContext(AppContext)
    let navigate = useNavigate()

    const Add = async ({ values, onSuccess, onError, endpoints }: { values: any, onSuccess: any, onError?: any, endpoints?: any }) => {
        const response = await postData(values, endpoints);
        const { data, error } = response;

        if (data) { onSuccess(data); }
        else if (error?.response?.status === 401) {
            localStorage.removeItem('token');
            navigate('/login');
            setUser({});
        }
        else { onError ? onError(error ?? error?.message ?? '') : console.log(error) }
    }

    const Edit = async ({ values, onSuccess, onError, endpoints }: { values: any, onSuccess: any, onError?: any, endpoints?: any }) => {
        const response = await putData(values, endpoints);
        const { data, error } = response;
        if (data) { onSuccess(data); }
        else if (error?.response?.status === 401) {
            localStorage.removeItem('token');
            navigate('/login');
            setUser({});
        }
        else { onError(error ?? error?.message ?? '') }
    }

    const Delete = async ({ onSuccess, onError, endpoints }: { onSuccess: any, onError?: any, endpoints?: any }) => {
        const response = await deleteData(endpoints);
        const { data, error } = response;
        if (data) { onSuccess(data); }
        else if (error?.response?.status === 401) {
            localStorage.removeItem('token');
            navigate('/login');
            setUser({});
        }
        else { onError ? onError(error ?? error?.message ?? '') : console.log(error) }
    }

    const Get = async ({ onSuccess, onError, endpoints }: { onSuccess: any, onError?: any, endpoints?: any }) => {
        const response = await getData(endpoints);
        const { data, error } = response;
        if (data) {
            onSuccess(data);
        } else if (error?.response?.status === 401) {
            localStorage.removeItem('token');
            navigate('/login');
            setUser({});
        } else {
            if (onError) {
                onError(error ?? error?.message ?? '');
            } else {
                console.log(error);
            }
        }
    }

    return { add: Add, edit: Edit, deleteData: Delete, get: Get }
}